import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { GeographicBadge } from './GeographicBadge';

const API = process.env.REACT_APP_BACKEND_URL + '/api/exclusion-geografica';
export const AssetExclusionPanel = ({ asset, user }) => {
  const [geo, setGeo] = useState(asset.exclusion_geografica);
  const [editing, setEditing] = useState(false);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const admin = ['admin', 'superadmin'].includes(user?.role);
  useEffect(() => {
    let active = true;
    axios.get(`${API}/activos/${asset.id}`, { withCredentials: true }).then(r => { if (active) setGeo(r.data); }).catch(() => {});
    return () => { active = false; };
  }, [asset]);
  const save = async (remove = false) => {
    if (remove && !window.confirm('¿Retirar la excepción de exclusión geográfica?')) return;
    setBusy(true);
    try {
      if (remove) await axios.delete(`${API}/activos/${asset.id}/excepcion`, { withCredentials: true });
      else await axios.put(`${API}/activos/${asset.id}/excepcion`, { motivo: reason }, { withCredentials: true });
      const r = await axios.get(`${API}/activos/${asset.id}`, { withCredentials: true });
      setGeo(r.data); setEditing(false); setReason('');
      toast.success(remove ? 'Excepción retirada' : 'Excepción autorizada');
    } catch (e) { toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'No se pudo guardar la excepción'); }
    finally { setBusy(false); }
  };
  return <section className="py-4 border-y border-slate-300/30 space-y-3" data-testid="asset-geographic-exclusion">
    <h2 className="text-base font-semibold" data-testid="asset-geo-title">Exclusión geográfica</h2>
    <GeographicBadge geo={geo} id={`detail-${asset.id}`} />
    {geo?.estado === 'sin_exclusion' && !geo.zonas.length && <p className="text-sm" data-testid="asset-geo-outside">Sin exclusión</p>}
    {geo?.excepcion && <p className="text-sm break-words" data-testid="asset-geo-exception">Excepción autorizada por {geo.excepcion.autorizado_nombre} · {new Date(geo.excepcion.autorizado_at).toLocaleString('es-ES')}<br />{geo.excepcion.motivo}</p>}
    {admin && !editing && <div className="flex flex-wrap gap-2">
      <button type="button" className="btn-secondary text-xs" data-testid="asset-geo-except" onClick={() => { setReason(geo?.excepcion?.motivo || ''); setEditing(true); }}>{geo?.excepcion ? 'Modificar motivo de excepción' : 'Exceptuar este activo de la exclusión geográfica'}</button>
      {geo?.excepcion && <button type="button" className="btn-secondary text-xs" data-testid="asset-geo-remove" disabled={busy} onClick={() => save(true)}>Retirar excepción</button>}
    </div>}
    {admin && editing && <form className="space-y-3 max-w-xl" onSubmit={e => { e.preventDefault(); save(); }}>
      <label className="text-sm block">Motivo obligatorio<textarea className="input-base mt-1" data-testid="asset-geo-reason" value={reason} onChange={e => setReason(e.target.value)} required maxLength={2000} /></label>
      <div className="flex flex-wrap gap-2"><button type="submit" className="btn-primary text-sm" data-testid="asset-geo-confirm" disabled={busy || !reason.trim()}>Confirmar excepción</button><button type="button" className="btn-secondary text-sm" data-testid="asset-geo-cancel" onClick={() => setEditing(false)} disabled={busy}>Cancelar</button></div>
    </form>}
  </section>;
};